// Import the public components directly
import JobDetail from '../../public/JobDetail';
import { ThemeProvider } from '../../../contexts/ThemeContext';

const Jobs = () => {
  return (
    <>
      {/* SEO Settings */}
      <meta name="robots" content="noindex, nofollow" />
      
      <ThemeProvider theme="candidate">
        <JobDetail />
      </ThemeProvider>
    </>
  );
};

export default Jobs;